/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portfolio_HeadingInputs */

const et_portfolio_heading = /** @type {(inputs: Portfolio_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edulood`)
};

const en_portfolio_heading = /** @type {(inputs: Portfolio_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our Work`)
};

/**
* | output |
* | --- |
* | "Our Work" |
*
* @param {Portfolio_HeadingInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const portfolio_heading = /** @type {((inputs?: Portfolio_HeadingInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portfolio_HeadingInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_portfolio_heading(inputs)
	return en_portfolio_heading(inputs)
});